// 身份证校验
export function validatorId(value) {
    const res = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/;
    if (!value) {
        return '请输入身份证';
    }
    if (!res.test(value)) {
        return '身份证格式错误';
    }
}
//手机号
export function validatorPhone(value) {
    var regTel = /^(?:(?:\+|00)86)?1\d{10}$/
    if (!value) {
        return '请输入手机号'
    }
    if (!regTel.test(value)) {
        return '手机号格式错误'
    }
}
//输入密码
export function validatorPassword(val) {
    var reg = /^[\w]{6,18}$/;
    if (!reg.test(val)) {
        return '请输入6-18位字母、数字'
    }
}
//确认密码
export function validatorConfirmPassword(val,val_) {
    var reg = /^[\w]{6,18}$/;
    if (val!==val_) {
        return '密码输入不一致,请重试'
    }
}